<template>
  <div
    class="cp-card-event-program"
  >
    <div class="top">
      <div class="event-category">
        {{ item.category }}
      </div>
      <h2>{{ item.title }}</h2>
      <a
        v-if="item.url !== ''"
        :href="item.url"
        class="link-underline"
      > {{ btnEventDetailLabel }}</a>
      <div class="event-tag">
        <span
          v-for="(tag, index) in item.tags"
          :key="index"
        >{{ tag.name }}</span>
      </div>
    </div>
    <div class="bottom">
      <div class="event-location">
        {{ item.location }}
      </div>
      <div class="event-date-hour">
        <div class="event-date">
          <div class="date-start">
            {{ item.date }}
          </div>
          <div
            v-if="item.dateEnd"
            class="date-end"
          >
            {{ item.dateEnd }}
          </div>
        </div>
        <div class="event-hour">
          {{ item.hour }}
        </div>
      </div>
      <template v-if="item.eventPast">
        <div class="past-event">
          <div>{{ pastEvent }}</div>
        </div>
      </template>
      <template v-else>
        <div
          class="link-add-agenda addeventatc"
          :title="addToCalendarLabel"
          data-styling="none"
        >
          <div
            class="btn"
            @click="eventGTM(item)"
          >
            {{ addToCalendarLabel }}
          </div>
          <span class="start">
            {{ item.addToCalendar.start }}
          </span>
          <span class="end">
            {{ item.addToCalendar.end }}
          </span>
          <span class="timezone">
            {{ item.addToCalendar.timezone }}
          </span>
          <span class="title">
            {{ item.addToCalendar.title }}
          </span>
          <span class="description">
            {{ item.addToCalendar.description }}
          </span>
          <span class="location">
            {{ item.addToCalendar.location }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    addToCalendarLabel: {
      type: String,
      required: true,
    },
    btnEventDetailLabel: {
      type: String,
      required: true,
    },
    pastEvent: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addeventatc.refresh();
    })
  },
  methods: {
    eventGTM(e) {
      window.dataLayer.push({ event: 'gaEvent', eventCategory: 'Add to agenda', eventAction: e.category })
    },
  },
}
</script>
